function x(){return"xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g,(x=>{let t=16*Math.random()|0;return("x"==x?t:3&t|8).toString(16)}))}export{x as default};
//# sourceMappingURL=uuid.js.map
